import '../../scss/pages/_terms.scss';

import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useConfig } from '~components/hooks';

export default function Agreement() {
  const { t } = useTranslation();
  const getConfig = useConfig();

  return (
    <>
      <Helmet>
        <title>
          {t('CSCASE User Agreement', { hostname: getConfig?.hostname })}
        </title>
        <meta
          name="description"
          content={t('Read the user agreement and full list of services', {
            hostname: getConfig?.hostname,
          })}
        />
      </Helmet>
      <div className="page-terms">
        <h1>
          {t('Terms of use', {
            hostname: getConfig?.hostname,
          })}
        </h1>
        <div className="terms-block">
          <div>
            {t('agreement_0_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            {t('agreement_0_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            {t('agreement_0_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            {t('agreement_0_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            {t('agreement_0_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            1.
            {t('agreement_1_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.1</span>{' '}
            {t('agreement_1_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.1.1</span>
            {t('agreement_1_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.1.2</span>
            {t('agreement_1_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.1.3</span>
            {t('agreement_1_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.1.4</span>
            {t('agreement_1_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.1.5</span>
            {t('agreement_1_6', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.1.6</span>
            {t('agreement_1_7', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_1_7_2', {
                  hostname: getConfig?.hostname,
                })}
                ;
              </li>
              <li>
                {t('agreement_1_7_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_1_7_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span> 1.1.7</span>
            {t('agreement_1_8', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 1.2</span>{' '}
            {t('agreement_1_9', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            2.{' '}
            {t('agreement_2_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.1</span>
            {t('agreement_2_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.2</span>
            {t('agreement_2_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.3</span>
            {t('agreement_2_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.4</span>
            {t('agreement_2_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.6</span>{' '}
            {t('agreement_2_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.7</span>
            {t('agreement_2_6', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.8</span>
            {t('agreement_2_7', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.9</span>
            {t('agreement_2_8', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.10</span>
            {t('agreement_2_9', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.11</span>
            {t('agreement_2_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.11.1</span>
            {t('agreement_2_11_1', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_2_11_2', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_11_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_11_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span> 2.11.2</span>
            {t('agreement_2_12_1', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_2_12_2', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_12_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_12_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_12_5', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_12_6', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span> 2.11.3</span>
            {t('agreement_2_13', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.12</span>
            {t('agreement_2_14', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.13</span>
            {t('agreement_2_15', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.14</span>
            {t('agreement_2_16', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.15</span>{' '}
            {t('agreement_2_17_1', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_2_17_2', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_17_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_17_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_17_5', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span> 2.16</span>
            {t('agreement_2_18', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.17</span>
            {t('agreement_2_19', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.18</span>
            {t('agreement_2_20', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.19</span>
            {t('agreement_2_21', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.20</span>
            {t('agreement_2_22', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.21</span>
            {t('agreement_2_23', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.22</span>
            {t('agreement_2_24_1', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_2_24_2', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_24_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_24_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_2_24_5', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span> 2.23</span>
            {t('agreement_2_24', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 2.24</span>
            {t('agreement_2_25', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            3.{' '}
            {t('agreement_3_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.1</span>
            {t('agreement_3_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.2</span>{' '}
            {t('agreement_3_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.3</span>
            {t('agreement_3_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.4</span>
            {t('agreement_3_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.6</span>{' '}
            {t('agreement_3_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.6.1</span>
            {t('agreement_3_6', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.6.2</span>
            {t('agreement_3_7', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.6.3</span>
            {t('agreement_3_8', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.6.4</span>
            {t('agreement_3_9', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.7</span>
            {t('agreement_3_10', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.8</span>
            {t('agreement_3_11', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 3.9</span>
            {t('agreement_3_12', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            4.{' '}
            {t('agreement_4_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.1</span>
            {t('agreement_4_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.2</span>
            {t('agreement_4_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.3</span>
            {t('agreement_4_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.4</span>
            {t('agreement_4_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.5</span>{' '}
            {t('agreement_4_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.5.1</span>{' '}
            {t('agreement_4_6', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.5.2</span>{' '}
            {t('agreement_4_7', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.5.3</span>{' '}
            {t('agreement_4_8', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 4.6</span>
            {t('agreement_4_9_1', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_4_9_2', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_4_9_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_4_9_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_4_9_5', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_4_9_6', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span>4.7</span>{' '}
            {t('agreement_4_7zen', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span>4.7.1</span>{' '}
            {t('agreement_4_71zen', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span>4.8</span>{' '}
            {t('agreement_4_8zen', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span>4.8.1</span>{' '}
            {t('agreement_4_81zen', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span>4.9</span>{' '}
            {t('agreement_4_9zen', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span>4.9.1</span>{' '}
            {t('agreement_4_91zen', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            5.{' '}
            {t('agreement_5_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.1</span>
            {t('agreement_5_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.2</span>
            {t('agreement_5_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.3</span>
            {t('agreement_5_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.4</span>
            {t('agreement_5_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.5</span>{' '}
            {t('agreement_5_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.6</span>{' '}
            {t('agreement_5_6', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.7</span>{' '}
            {t('agreement_5_7', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 5.8</span>{' '}
            {t('agreement_5_8', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            6.{' '}
            {t('agreement_6_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 6.1</span>
            {t('agreement_6_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 6.2</span>
            {t('agreement_6_2_1', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_6_2_2', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_6_2_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_6_2_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span> 6.3</span>
            {t('agreement_6_3_1', {
              hostname: getConfig?.hostname,
            })}
            <ul>
              <li>
                {t('agreement_6_3_2', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_6_3_3', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_6_3_4', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_6_3_5', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_6_3_6', {
                  hostname: getConfig?.hostname,
                })}
              </li>
              <li>
                {t('agreement_6_3_7', {
                  hostname: getConfig?.hostname,
                })}
              </li>
            </ul>
          </div>
          <div>
            <span> 6.4</span>
            {t('agreement_6_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 6.5</span>
            {t('agreement_6_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 6.6</span>
            {t('agreement_6_6', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            7.{' '}
            {t('agreement_7_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 7.1</span>
            {t('agreement_7_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 7.2</span>{' '}
            {t('agreement_7_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 7.3</span>{' '}
            {t('agreement_7_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          <div className="terms-title">
            8.{' '}
            {t('agreement_8_0', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 8.1</span>
            {t('agreement_8_1', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 8.2</span>
            {t('agreement_8_2', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 8.3</span>{' '}
            {t('agreement_8_3', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 8.4</span>
            {t('agreement_8_4', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 8.5</span>{' '}
            {t('agreement_8_5', {
              hostname: getConfig?.hostname,
            })}
          </div>
          <div>
            <span> 8.6</span>
            {t('agreement_8_6', {
              hostname: getConfig?.hostname,
            })}
            : https://
            {getConfig?.hostname}/agreement.
          </div>
          <div>
            <span> 8.7</span>
            {t('agreement_8_7', {
              hostname: getConfig?.hostname,
            })}
          </div>
        </div>
        <div className="terms-block">
          {/* <div>
            <span>Company</span>
            EY CYPRUS ADVISORY SERVICES LIMITED
          </div>
          <div>
            <span>Reg. number:</span>
            ОН 42879
          </div>
          <div>
            <span>Beneficiary’s address:</span>
            Stasinova 6, JEAN NOVEL TOWER, FIRST FLOOR 1060, NICOSIA, CYPRUS
          </div> */}

          {getConfig.isRU && (
            <div>
              <span>
                Прием и отправка платежей через АО &quot;Киви Банк&quot;
                осуществляется
              </span>
              ИП МУХА ВЛАДИМИР БОГДАНОВИЧ ИНН: 614588962120 ОГРНИП:
              321619600095864
            </div>
          )}
        </div>
      </div>
    </>
  );
}
